import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import {
  roleNameBlock,
  nameOnlyBlock,
  blurbBlock,
  songsBlock,
  logoBlock,
  Scrollx_Block_icon,
  info,
} from "../../../assets/icons";

import {
  updateCurrentBlockState,
  moveBlock
} from "../../../Redux/actions/projectActions";
import { useDispatch } from "react-redux";

const getProjectIcon = (blockType) => {
  switch (blockType) {
    case "rolename":
      return roleNameBlock;
    case "nameonly":
      return nameOnlyBlock;
    case "logo":
      return logoBlock;
    case "blurb":
      return blurbBlock;
    case "songs":
      return songsBlock;
    default:
      return nameOnlyBlock;
  }
};
const scrollTo = (parent, child) => {
  let parent1 = document.getElementById(parent);
  let child1 = document.getElementById(child);
  if (child1&&parent1){
    parent1?.scrollTo({
      behavior: "smooth",
      top:
        child1.offsetTop -
        document.getElementById("navbar_1").offsetHeight -
        150,
    });
  }
  
};
const SidebarDD = ({ currentBlockId, blocks, projectData }) => {
  const dispatch = useDispatch();
  const [draggedBlockId, setDraggedBlockId] = useState(null);
  const currentBlockIdx = projectData?.currentBlock?.idx;
  const setSelectedBlock = (idx, blockId) => {
    dispatch(updateCurrentBlockState(blockId, idx));
  }

  useEffect(() => {
    try {
       scrollTo("menu-item-paent", "content" + currentBlockIdx);
    } catch (error) {
      console.log(error);
    }
  }, );
  const handleDragStart = (event, blockId) => {
    setDraggedBlockId(blockId);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", blockId);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };
  const handleDrop = (event, blockId,targetIdx) => {
    event.preventDefault();
    const sourceIdx = blocks.findIndex((block) => block._id === draggedBlockId);
    if (sourceIdx !== targetIdx) {
      dispatch(moveBlock(sourceIdx, targetIdx));
      dispatch(updateCurrentBlockState(blockId, targetIdx));
    }
    setDraggedBlockId(null);
  };

  return (
    <div className="Sidebar" id="content">
      <div className="SideTop justify-between">
        <div className="flex items-center">
        <img className="w-2.5 mr-3" src={Scrollx_Block_icon}  />
        <span>Blocks</span>
        </div>
        <div className="">
            <img
              className="w-5"
              src={info}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => window.open(`/help/66f3ec3e07e246eceda19874`)}
            />
          </div>
      </div>
      <div className="menu-item " id="menu-item-paent" >
        {blocks?.map((block, idx) => {
          return (
            <div
              className={currentBlockId === block._id ? "menuItemActive" : "menuItem"}
              id={"content" + idx}
              key={block._id}
              onClick={() => setSelectedBlock(idx, block?._id)}
              draggable={true}
              onDragStart={(event) => handleDragStart(event, block?._id)}
              onDragOver={handleDragOver}
              onDrop={(event) => handleDrop(event, block._id,idx)}
            >
              <img className="icon" src={getProjectIcon(block?.block_type)} alt="" />
              <span>{block?.block_name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarDD;